import { useAppTranslation } from 'app/hooks';
import React from 'react';
import { UserBankbookResponseModel } from 'models/wallet';
import { CloseCircleOutlined } from '@ant-design/icons';
import EmptyTableIcon from 'assets/icons/EmptyTableIcon';

interface ListUserBankbookProps {
  userBankbooks?: UserBankbookResponseModel[];
  onDeleteUserBankbook: (id: number) => void;
  clickable?: boolean;
  onClick?: (item: UserBankbookResponseModel) => void;
}

const ListUserBankbook: React.FunctionComponent<ListUserBankbookProps> = ({
  userBankbooks,
  onDeleteUserBankbook,
  clickable = false,
  onClick = () => {},
}) => {
  const t = useAppTranslation();

  const handleDeleteItem = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    item: UserBankbookResponseModel,
  ) => {
    event.stopPropagation();
    onDeleteUserBankbook(item.id);
  };

  return (
    <div className="w-100 p-2 max-height-400 overflow-x-auto flex flex-col items-center gap-2">
      {userBankbooks?.length ? (
        userBankbooks.map((bankbook) => (
          <div
            key={`bankbook-${bankbook.id}`}
            className={`border border__rounded p-2 flex flex-col ${
              clickable && 'cursor-pointer'
            } banking__card`}
            onClick={() => {
              if (clickable) onClick(bankbook);
            }}
          >
            <div className="flex justify-between">
              <span className="font-bold">
                {bankbook.name} ({bankbook.type})
              </span>
              <button onClick={(event) => handleDeleteItem(event, bankbook)} className="icon-close">
                <CloseCircleOutlined className="primary-text-color" />
              </button>
            </div>

            {bankbook.type === 'CARD' ? (
              <div className="banking__info ">
                <span className="font-bold">{t('cashier.disbursementNumber')}:&nbsp;</span>
                <span>{bankbook.disbursementNumber}</span>
              </div>
            ) : (
              <div>
                <div className="banking__info">
                  <span className="font-bold">{t('cashier.routingNumber')}:&nbsp;</span>
                  <span>{bankbook.routingNumber}</span>
                </div>
                <div className="banking__info">
                  <span className="font-bold">{t('cashier.branchTransitNumber')}:&nbsp;</span>
                  <span>{bankbook.branchTransitNumber}</span>
                </div>
                <div className="banking__info">
                  <span className="font-bold">{t('cashier.accountNumber')}:&nbsp;</span>
                  <span>{bankbook.accountNumber}</span>
                </div>
              </div>
            )}
          </div>
        ))
      ) : (
        <div className="match-list__body__empty">
          <EmptyTableIcon />
        </div>
      )}
    </div>
  );
};

export default ListUserBankbook;
